import noop from 'lodash/noop';
import { MOVE } from '../model/operation.tsx';
import {
	INITIALIZE_APP_PROPS,
	GET_RELATED_ISSUES_COUNT,
	SET_RELATED_ISSUES_COUNT,
	SHOW_DIALOG,
	DELETE_VERSION,
	SET_VERSION_FOR_FIELD,
	DELETION_SUCCESS,
	DELETION_FAILURE,
	SET_OPERATION_FOR_FIELD,
	CANCEL,
	type Action,
} from './actions.tsx';
import type { State } from './types.tsx';

export const defaultState: State = {
	projectKey: '',
	onError: noop,
	onSuccess: noop,
	onCancel: noop,
	onOpened: noop,
	version: {
		name: '',
		id: '',
	},
	fields: {},
	inProgress: false,
	isVisible: false,
};

const reducer = (state: State = defaultState, action: Action): State => {
	switch (action.type) {
		case INITIALIZE_APP_PROPS:
			return {
				...state,
				...action.payload,
				version: {
					name: action.payload.version.name,
					id: action.payload.version.id,
				},
				fields: {},
			};
		case SET_RELATED_ISSUES_COUNT:
			return {
				...state,
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				fields: Object.entries(action.payload).reduce<Record<string, any>>(
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					(fields, [fieldId, field]: [any, any]) => {
						// eslint-disable-next-line no-param-reassign
						fields[fieldId] = {
							relatedField: field,
							operation: MOVE,
						};
						return fields;
					},
					{},
				),
			};
		case SHOW_DIALOG:
			return {
				...state,
				isVisible: true,
			};
		case SET_VERSION_FOR_FIELD:
			if (Object.prototype.hasOwnProperty.call(state.fields, action.payload.fieldId)) {
				return {
					...state,
					fields: {
						...state.fields,
						[action.payload.fieldId]: {
							...state.fields[action.payload.fieldId],
							targetVersion: action.payload.target,
						},
					},
				};
			}
			return state;

		case SET_OPERATION_FOR_FIELD:
			if (Object.prototype.hasOwnProperty.call(state.fields, action.payload.fieldId)) {
				return {
					...state,
					fields: {
						...state.fields,
						[action.payload.fieldId]: {
							...state.fields[action.payload.fieldId],
							operation: action.payload.operation,
						},
					},
				};
			}
			return state;
		case DELETE_VERSION:
			return {
				...state,
				inProgress: true,
			};
		case DELETION_FAILURE:
			return {
				...state,
				inProgress: false,
			};
		case DELETION_SUCCESS:
		case CANCEL:
			return {
				...state,
				inProgress: false,
				isVisible: false,
			};
		case GET_RELATED_ISSUES_COUNT:
			return state;
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};

export default reducer;
